module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ql-cue-layer-picker"
  }, [(_vm.locked || !_vm.editable) ? _c('div', {
    staticClass: "ql-button-container"
  }, [_c('md-button', {
    staticClass: "ql-cue-layer-picker",
    style: ({
      backgroundColor: _vm.currentLayer.color
    })
  })], 1) : _c('md-menu', {
    ref: "layerMenu",
    attrs: {
      "md-size": "4"
    }
  }, [_c('md-button', {
    staticClass: "ql-cue-layer-picker",
    style: ({
      backgroundColor: _vm.currentLayer.color
    }),
    attrs: {
      "md-menu-trigger": ""
    }
  }, [_c('md-tooltip', {
    attrs: {
      "md-direction": "top"
    }
  }, [_vm._v("Click to change layer")])], 1), _vm._v(" "), _c('md-menu-content', _vm._l((_vm.layers), function(layer) {
    return _c('md-menu-item', {
      key: layer.id,
      on: {
        "selected": function($event) {
          _vm.selectLayer(layer.id)
        }
      }
    }, [_c('span', {
      staticClass: "ql-cue-layer-picker",
      style: (_vm.style(layer))
    }), _vm._v(" "), _c('span', {
      staticClass: "ql-cue-layer-picker-option"
    }, [_vm._v(_vm._s(layer.title))])])
  }))], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d9ec21ba","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sample/components/project/cues/layer-picker.vue
// module id = 684
// module chunks = 2